import { supabase } from "./supabase";
import { fromDbTool, toDbToolInsert } from "../lib/mappers";

const TOOL_COLUMNS = "id, dpr_id, item_id, description, vessel, sort_order";

const listTools = async (dprId) => {
  const { data, error } = await supabase
    .from("tool_entries")
    .select(TOOL_COLUMNS)
    .eq("dpr_id", dprId)
    .order("sort_order", { ascending: true });

  if (error) throw error;
  return (data ?? []).map(fromDbTool);
};

const createTool = async (entry) => {
  const payload = toDbToolInsert(entry);
  const { data, error } = await supabase
    .from("tool_entries")
    .insert(payload)
    .select(TOOL_COLUMNS)
    .single();

  if (error) throw error;
  return fromDbTool(data);
};

const updateTool = async (id, entry) => {
  const { data, error } = await supabase
    .from("tool_entries")
    .update({
      item_id: entry.itemId,
      description: entry.description,
      vessel: entry.vessel || "",
      sort_order: entry.sortOrder ?? 0,
    })
    .eq("id", id)
    .select(TOOL_COLUMNS)
    .single();

  if (error) throw error;
  return fromDbTool(data);
};

const deleteTool = async (id) => {
  const { error } = await supabase
    .from("tool_entries")
    .delete()
    .eq("id", id);
  if (error) throw error;
};

export { listTools, createTool, updateTool, deleteTool };
